$(document).on('submit', '[data-cms-form]', function (event) {
  event.preventDefault();
  const $form = $(this);
  $form.addClass('mask mask--light');

  $.ajax({
    url: $form.attr('action'),
    method: 'POST',
    data: new FormData(this),
    processData: false,
    contentType: false,
    success: (resp) => {
      $form.closest('[data-cms-form-container]').replaceWith(resp);
      if ($(this).data('cms-form') !== '') {
        window.dataLayer.push({
          event: `${$(this).data('cms-form')}_submit_success`,
        });
      }
    },
    error: () => {
      $form.removeClass('mask mask--light');
    },
  });
});

$(document).on('click', '[data-gallery-image-zoom]', function (event) {
  event.preventDefault();
  const id = $(this).closest('.cms-gallery').attr('id')
    .split('-')
    .slice(-1)[0];
  const slide = $(this).attr('data-gallery-image-zoom');
  const reveal = $(`[data-gallery-zoom-reveal-${id}]`);
  reveal.find('.owl-carousel').trigger('to.owl.carousel', [slide, 1]);
  reveal.foundation('open');
  setTimeout(() => {
    reveal.get(0).focus();
  }, 0);
});

$(document).on('keyup', '[data-gallery-zoom-reveal]', (event) => {
  if (event.keyCode === 37) {
    $('[data-gallery-zoom-reveal]').find('[data-carousel]').data('owl.carousel').prev();
  } else if (event.keyCode === 39) {
    $('[data-gallery-zoom-reveal]').find('[data-carousel]').data('owl.carousel').next();
  }
});

$(window).on('load', () => {
  const $contactCards = $('[data-contact-details]');
  $contactCards.each(function () {
    const $this = $(this);
    $.ajax({
      url: $this.data('contact-details'),
      method: 'GET',
      success: (resp) => {
        setTimeout(() => {
          $this.closest('.cms-vcard').replaceWith(resp);
        }, 500);
      },
      error: (resp) => {
        console.error(resp);
      },
    });
  });
});
